import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { LANGUAGE_OPTIONS } from '@/services/user/constant'
import { queryUserLanguage } from '@/services/user/query'

import { KeyValue } from '@/components/ui/key-value'

export const Route = createFileRoute('/dashboard/languages')({
  component: RouteComponent,
})

function RouteComponent() {
  const languagesQry = useSuspenseQuery(queryUserLanguage())
  const languages = languagesQry.data

  return (
    <div className="rounded-lg border-t-4 border-yes-600 bg-background">
      <div className="border-b px-4 py-4">
        <h2 className="font-semibold">Bahasa</h2>
      </div>
      <div className="divide-y divide-gray-200 px-4">
        {languages?.map(({ id, language, language_level }) => {
          const languageOptions = LANGUAGE_OPTIONS.find(
            (y) => y.value === language.toUpperCase()
          )
          return (
            <div key={id} className="grid grid-cols-2 py-4">
              <KeyValue label="Bahasa" value={language} />
              <KeyValue
                label="Level Bahasa"
                value={
                  languageOptions?.level.find(
                    (y) => y.value === language_level?.toUpperCase()
                  )?.label
                }
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
